import React, { useState, useEffect } from 'react';
import {
  Card, Row, Col, ListGroup,
} from 'react-bootstrap';
import { dateRenderer } from '../../../services/formatSvc';
import TooltippedElement from '../../common/TooltippedElement';
import LabelBadge from '../../common/LabelBadge.tsx';
import {getCurrentStyle, status, status_ru} from '../../../helpers/passport';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Tooltip } from '@material-ui/core';
import { NavLink } from 'react-router-dom';

export default function CommonInfo({
  data, types, isPortfolioProject, acceptedData, policies
}) {
  const kpisItems = (data.kpis || [])
    .map((k,index) => (<ListGroup.Item style={{...getCurrentStyle(data.status,k,acceptedData?.kpis?.[index] ?? {},'name'),...{width:'100%'}}} key={k.id}>{`${k.num}) ${k.name}` }</ListGroup.Item>));

  const typeName = types && types.length && data.typeId && types.find((t) => t.id === data.typeId).name
    ? types.find((t) => t.id === data.typeId).name
    : null;

  return (
    <div className="read-only">
      <Card className="mb-4">
        <Card.Header className="d-flex justify-content-between align-items-center p-4">
          <Card.Title className="m-0" style={{whiteSpace:'nowrap'}}>Общая информация</Card.Title>
          <div className="d-flex gap-1 flex-wrap flex-row-reverse">
            {data.labels.map(label => <LabelBadge labelName={label.name} />)}
          </div>
        </Card.Header>
        <Card.Body className="p-4">
          <Row className="mb-4">
            <Col md={4}>
              <Card.Subtitle className="mb-2 text-muted">Номер проекта</Card.Subtitle>
              <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'fullNumber')}>{data.fullNumber}</Card.Text>
            </Col>
            <Col md={4}>
              <Card.Subtitle className="mb-2 text-muted">Версия</Card.Subtitle>
              <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'version')}>{data.version}</Card.Text>
            </Col>
            <Col md={4}>
              <Card.Subtitle className="mb-2 text-muted">Дата утверждения версии</Card.Subtitle>
              <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'approvedOn')}>{dateRenderer(data.approvedOn)}</Card.Text>
            </Col>
          </Row>
          <Row className="mb-4">
            <Card.Subtitle className="mb-2 text-muted">Название</Card.Subtitle>
            <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'name')}>{data.name}</Card.Text>
          </Row>
          <Row className="mb-4">
            <Col md={4}>
              <Card.Subtitle className="mb-2 text-muted">Дата начала проекта</Card.Subtitle>
              <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'startDate')}>{dateRenderer(data.startDate)}</Card.Text>
            </Col>
            <Col md={4}>
              <Card.Subtitle className="mb-2 text-muted">Дата окончания проекта</Card.Subtitle>
              <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'endDate')}>{dateRenderer(data.endDate)}</Card.Text>
            </Col>
            <Col md={4}>
              <Card.Subtitle className="mb-2 text-muted">Дата закрытия проекта</Card.Subtitle>
              <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'closedOn')}>{dateRenderer(data.closedOn)}</Card.Text>
            </Col>
          </Row>
          <Row className="mb-4">
            {(
            <Col md={4}>
              <Card.Subtitle className="mb-2 text-muted">Тип проекта</Card.Subtitle>
              <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'typeId')}>{typeName}</Card.Text>
            </Col>
            )}
            <Col md={4}>
              <Card.Subtitle className="mb-2 text-muted d-flex align-items-center gap-1">
                ГРНТИ
                <Tooltip
                  placement="top"
                  title={<p style={{fontSize: 12}}>
                    Код программы государственного рубрикатора научно-технической информации в соответствии с
                    {' '}
                    <a
                      href="https://grnti.ru/"
                      target='_blank' rel='noreferrer noopener'
                      style={{color: '#7FC7FF'}}
                    >
                      https://grnti.ru/
                    </a>
                  </p>}
                  interactive
                >
                  <HelpOutlineIcon style={{ opacity: '0.66'}} fontSize="inherit" />
                </Tooltip>
              </Card.Subtitle>
              <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'grntis')}>
                {data?.grntis && data.grntis.length > 0 ? <ul style={{ listStyle: 'none' }}>
                  {(data.grntis || []).map(grnti => <li>{grnti.num} {grnti.name}</li>)}
                </ul> : '-'}
              </Card.Text>
            </Col>
            <Col md={4}>
              <Card.Subtitle className="mb-2 text-muted d-flex align-items-center gap-1">
                Приоритетные направления НТР
                <Tooltip
                  placement="top"
                  title={<p style={{fontSize: 12}}>Приоритетные направления научно-технологического развития</p>}
                >
                  <HelpOutlineIcon style={{ opacity: '0.66'}} fontSize="inherit" />
                </Tooltip>
              </Card.Subtitle>
              <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'mainSciTechDirection.name')}>
                {data?.mainSciTechDirection?.name || '-'}
              </Card.Text>
            </Col>
          </Row>
          {!!data.policyId && (
          <Row className="mb-4">
            <Card.Subtitle className="mb-2 text-muted">Портфель</Card.Subtitle>
            <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'policy.name')}>{policies.find(policy => policy.id === data.policyId)?.name}</Card.Text>
          </Row>
          )}
          <Row className="mb-4">
            <Col md={8}>
              <Card.Subtitle className="mb-2 text-muted">Стратегический проект / Политика</Card.Subtitle>
              <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'strategy.name')}>{data.strategy?.name ?? data.strategyName ?? 'Отсутствует'}</Card.Text>
            </Col>
            {data.prevMovedVersion && <Col md={4}>
              <Card.Subtitle className="mb-2 text-muted">Перемещен из</Card.Subtitle>
              <Card.Text>
                <NavLink
                  to={`/${data.prevMovedVersion.strategy.type === 'strategy' ? 'strats' : 'policies'}/${data.prevMovedVersion.strategy.id}/projs/${data.prevMovedVersion.id}`}
                >
                  {data.prevMovedVersion.strategy.name}
                </NavLink>
              </Card.Text>
            </Col>}
            {data.nextMovedVersion && <Col md={4}>
              <Card.Subtitle className="mb-2 text-muted">Перемещен в</Card.Subtitle>
              <Card.Text>
                <NavLink
                  to={`/${data.nextMovedVersion.strategy.type === 'strategy' ? 'strats' : 'policies'}/${data.nextMovedVersion.strategy.id}/projs/${data.nextMovedVersion.id}`}
                >
                  {data.nextMovedVersion.strategy.name}
                </NavLink>
              </Card.Text>
            </Col>}
          </Row>
          {isPortfolioProject && (
            <Row className="mb-4">
              <Col md={4}>
                <Card.Subtitle className="mb-2 text-muted">Портфель</Card.Subtitle>
                <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'portfolio.name')}>{data.portfolio ? data.portfolio.name : ''}</Card.Text>
              </Col>
              <Col md={4}>
                <Card.Subtitle className="mb-2 text-muted">Категория проекта</Card.Subtitle>
                <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'category?.name')}>
                  {data.category ? data.category.name : 'Нет категории'}
                  {data.category && data.category.descr && (
                    <TooltippedElement tooltip={data.category.descr} />
                  )}
                </Card.Text>
              </Col>
            </Row>
          )}
          {!!data.policyId && (
          <Row className="mb-4">
            <Card.Subtitle className="mb-2 text-muted">Ключевое направление</Card.Subtitle>
            <Card.Text style={getCurrentStyle(data.status,data,acceptedData,'policyArea.name')}>{data.policyArea?.name ?? 'Не указано'}</Card.Text>
          </Row>
          )}
          <Row className="mb-4">
            <Card.Subtitle className="mb-2 text-muted">Показатели программы</Card.Subtitle>
            <Card.Text>
              <ListGroup>
                {kpisItems}
              </ListGroup>
            </Card.Text>
          </Row>
          {/* <Row>
            <Card.Subtitle className="mb-2 text-muted">Общий бюджет проекта</Card.Subtitle>
            <Card.Text>3 180 000 руб., в т.ч. из гранта 2 180 000 руб.</Card.Text>
          </Row> */}
        </Card.Body>
      </Card>
    </div>
  );
}
